const INTERVAL_SLIDES_DURATION = 6000;

Hop.defineModule('hp-header-carousel', (root) => {
    let slides: ArrayLike<Element> = [];
    let index = 0;
    let numberTotalOfSlides = 0;
    let timer: number | null = null;

    function findSlides() {
        slides = root.children;
        numberTotalOfSlides = slides.length;
    }

    function displaySlidesOpacity(slideIndex: number) {
        const currentSlide = slides[slideIndex];

        currentSlide.classList.add('active');

        Array.from(slides).forEach((slide) => {
            if (slide !== currentSlide) {
                slide.classList.remove('active');
            }
        });
    }

    function goToNextSlide() {
        index === numberTotalOfSlides && (index = 0);
        displaySlidesOpacity(index);
        index++;
    }

    function stopCarousel() {
        if (timer) {
            clearInterval(timer);
        }

        timer = null;
    }

    function startCarousel() {
        timer = window.setInterval(() => goToNextSlide(), INTERVAL_SLIDES_DURATION);
    }

    function playAutoCarousel() {
        stopCarousel();
        startCarousel();
    }

    function init() {
        findSlides();
        goToNextSlide();
        playAutoCarousel();
    }

    init();

    return function destroy() {
        stopCarousel();
    };
});
